import apiBase from "./apiBase";

class BeaconApi {
  static saveBeacon(body) {
    return apiBase.create().post("/operations/beacon", body);
  }

  static getBeacon(zoneId) {
    return apiBase.create().get(`/operations/beacon/zone/${zoneId}`);
  }

  static removeBeacon(beaconId) {
    return apiBase.create().delete(`/operations/beacon/${beaconId}`);
  }
}

export default BeaconApi;
